import { Camera } from "lucide-react";

/**
 * Editorial "Photography Brief" placeholder — renders when a real commissioned
 * photo has not yet been uploaded for a service. Displays the exact stock
 * search criteria (subject, keywords, suggested source) so the creative team
 * knows precisely what to commission or source.
 */
export default function PhotoBriefPlaceholder({ brief, serviceName }) {
  if (!brief) return null;
  return (
    <div
      className="absolute inset-0 flex flex-col overflow-hidden"
      data-testid="photo-brief-placeholder"
      style={{
        background:
          "linear-gradient(155deg, #0F0F11 0%, #1A1A1D 45%, #0B0B0D 100%)",
      }}
    >
      {/* Subtle blueprint grid */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(198,168,124,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(198,168,124,0.05) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      {/* Corner marks (film reel style) */}
      <div className="absolute top-4 left-4 w-6 h-6" style={{ borderTop: "1px solid var(--gold)", borderLeft: "1px solid var(--gold)" }} />
      <div className="absolute top-4 right-4 w-6 h-6" style={{ borderTop: "1px solid var(--gold)", borderRight: "1px solid var(--gold)" }} />
      <div className="absolute bottom-4 left-4 w-6 h-6" style={{ borderBottom: "1px solid var(--gold)", borderLeft: "1px solid var(--gold)" }} />
      <div className="absolute bottom-4 right-4 w-6 h-6" style={{ borderBottom: "1px solid var(--gold)", borderRight: "1px solid var(--gold)" }} />

      {/* Center camera icon + label */}
      <div className="relative flex-1 flex flex-col items-center justify-center px-8 text-center">
        <div
          className="w-16 h-16 flex items-center justify-center mb-6"
          style={{
            borderRadius: "var(--r-full)",
            background: "rgba(198,168,124,0.08)",
            border: "1px solid var(--line-gold)",
            boxShadow: "0 0 32px rgba(198,168,124,0.15)",
          }}
        >
          <Camera size={22} style={{ color: "var(--gold)" }} strokeWidth={1.3} />
        </div>
        <div className="font-mono text-[9px] uppercase tracking-[0.44em]" style={{ color: "var(--gold)" }}>
          Photography Brief
        </div>
        <div className="font-display text-xl md:text-2xl mt-4 max-w-xs leading-tight" style={{ color: "var(--text)", letterSpacing: "-0.015em" }}>
          {brief.subject}
        </div>
        <div className="hairline my-6 max-w-[200px]" />
        <div className="font-mono text-[9px] uppercase tracking-[0.28em] max-w-xs" style={{ color: "var(--text-3)", lineHeight: 1.9 }}>
          {brief.keywords.slice(0, 3).join(" · ")}
        </div>
        <div className="font-mono text-[8px] uppercase tracking-[0.28em] mt-6" style={{ color: "var(--gold-3)" }}>
          Source: {brief.sources}
        </div>
      </div>
    </div>
  );
}
